import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";
import { AuthService } from "../../app/auth/auth.service";
import { StateManagementService } from "../../providers/state-management/state-management.service";
import { ClaimManagementPage } from "./claim-management/claim-management";

@IonicPage()
@Component({
  selector: "billing",
  templateUrl: "billing.html",
})
export class BillingPage {
  rootPage: ClaimManagementPage;

  constructor(
    private stateManagement: StateManagementService,
    private navCtrl: NavController,
    private authSvc: AuthService
  ) {}

  ionViewDidLoad() {
    this.stateManagement.setAssessmentType("billing");
    this.stateManagement.setSectionId("billing");
  }

  ionViewCanEnter() {
    return this.authSvc.isAuthenticated();
  }

  navigate(entity: string) {
    this.navCtrl.push("CompanyResourcesListPage");
  }
}



// WEBPACK FOOTER //
// ./src/pages/billing/billing.ts